import React from 'react';
import { PickersDay } from '@mui/x-date-pickers';

const isDateInRange = (date, start, end) => {
  if (!start || !end) return false;
  const dt = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  const st = new Date(start.getFullYear(), start.getMonth(), start.getDate()).getTime();
  const et = new Date(end.getFullYear(), end.getMonth(), end.getDate()).getTime();
  return dt > st && dt < et;
};

const isDateStartOrEnd = (date, start, end) => {
  if (!start || !end) return false;
  const dt = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  const st = new Date(start.getFullYear(), start.getMonth(), start.getDate()).getTime();
  const et = new Date(end.getFullYear(), end.getMonth(), end.getDate()).getTime();
  return dt === st || dt === et;
};

const RangeDayPicker = ({ day, startDate, endDate, isMobile, ...other }) => {
  const dt = new Date(day.getFullYear(), day.getMonth(), day.getDate()).getTime();
  const isInRange = isDateInRange(day, startDate, endDate);
  const isStartOrEnd = isDateStartOrEnd(day, startDate, endDate);
  const isStartDate = startDate && dt === new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()).getTime();
  const isEndDate = endDate && dt === new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()).getTime();

  return (
    <PickersDay
      {...other}
      day={day}
      disableRipple
      onTouchEnd={(e) => {
        e.preventDefault();
        const btn = e.currentTarget;
        if (btn && typeof btn.click === 'function') btn.click();
      }}
      sx={{
        fontFamily: 'Noto Sans',
        fontWeight: 700,
        color: '#000000',
        borderRadius: '12px',
        touchAction: 'manipulation',
        transition: 'none',
        '&:hover': { backgroundColor: '#F0F0F0' },
        '&.Mui-focusVisible': { backgroundColor: 'transparent', outline: 'none' },
        ...(isMobile && { minWidth: 44, minHeight: 44 }),
        '&.MuiPickersDay-today': {
          border: 'none !important',
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: '3px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '4px',
            height: '4px',
            borderRadius: '50%',
            backgroundColor: (isStartDate || isEndDate) ? 'white' : '#027BC6',
          },
        },
        '&.Mui-selected': {
          backgroundColor: '#027BC6 !important',
          color: 'white !important',
          '&:hover': { backgroundColor: '#027BC6 !important' },
        },
        ...(isInRange && {
          backgroundColor: '#E5E5E5',
          color: '#666666',
          '&:hover': { backgroundColor: '#D5D5D5' },
          '&.Mui-focusVisible': { backgroundColor: '#E5E5E5' },
        }),
        ...(isStartOrEnd && {
          backgroundColor: '#027BC6',
          color: 'white',
          boxShadow: '0px 4px 10px #6A78F819',
          '&:hover': { backgroundColor: '#027BC6' },
          '&.Mui-focusVisible': { backgroundColor: '#027BC6' },
        }),
        ...(isStartDate && {
          backgroundColor: '#027BC6 !important',
          color: 'white !important',
          boxShadow: '0px 4px 10px #6A78F819 !important',
        }),
        ...(isEndDate && {
          backgroundColor: '#027BC6 !important',
          color: 'white !important',
          boxShadow: '0px 4px 10px #6A78F819 !important',
        }),
      }}
    />
  );
};

export default RangeDayPicker;
